/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetConnectLwasStautsRequest
 */
export interface RequestGetConnectLwasStautsRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetConnectLwasStautsRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestGetConnectLwasStautsRequest
     */
    userId?: number;
}

/**
 * Check if a given object implements the RequestGetConnectLwasStautsRequest interface.
 */
export function instanceOfRequestGetConnectLwasStautsRequest(value: object): value is RequestGetConnectLwasStautsRequest {
    return true;
}

export function RequestGetConnectLwasStautsRequestFromJSON(json: any): RequestGetConnectLwasStautsRequest {
    return RequestGetConnectLwasStautsRequestFromJSONTyped(json, false);
}

export function RequestGetConnectLwasStautsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetConnectLwasStautsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function RequestGetConnectLwasStautsRequestToJSON(json: any): RequestGetConnectLwasStautsRequest {
    return RequestGetConnectLwasStautsRequestToJSONTyped(json, false);
}

export function RequestGetConnectLwasStautsRequestToJSONTyped(value?: RequestGetConnectLwasStautsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

